module.exports = __webpack_public_path__ + "static/media/AMERICAN_EXPRESS.8b2dc247.png";